import { createSelector } from 'redux-orm';
import orm from '%paysera_seat_selection/js/seatSelection/redux/model';
import dbSelector from './dbSelector';

const selectHall = createSelector(
    orm,
    dbSelector,
    session => session.Hall.all().first() || null,
);

export default selectHall;
